/**
 *
 * @author Shuhin
 * @since 5/13/20
 *
 */
import React from "react";
import api from "../utility/api";
import { Map } from "immutable";
import List from "../screens/list/";
import { connect } from "react-redux";
import DatePicker from 'material-ui/DatePicker';
import utils from '../utility/utils';
import appConstants from "../utility/app-constants";
import { asyncStart, asyncEnd, showFeedback } from "../actions/application";
import { white } from "material-ui/styles/colors";
import RaisedButton from "material-ui/RaisedButton";
import {
  getListUIPreference,
  setListUIPreference,
} from "../utility/local-storage";
import ManualPaymentDialog from "../screens/pending-payments/manual-payment-dialog.component";
import {
  isConnected,
  setPaymentListUpdater,
  unsetPaymentListUpdater,
} from "../utility/socket-handler";

class PendingPaymentsTableView extends React.Component {
  constructor() {
    super(...arguments);
    let { defaultSort, pageSize } = this.loadUIPreferences();

    this.state = {
      socketConnection: "",
      pendingPaymentsList: Map(),
      sortPref: defaultSort,
      pageSize,
      manualPaymentDialogOpen: false,
      selectedMission: null,
    };
  }

  componentDidMount() {
    this.getPendingPaymentList().then(() => {
      setPaymentListUpdater({
        add: (mission) => this.addMission(mission),
        remove: (id) => this.removeMission(id),
        online: () => this.setState({ socketConnection: "ONLINE" }),
        offline: () => this.setState({ socketConnection: "OFFLINE" }),
      });

      this.setState({socketConnection: isConnected() ? "ONLINE" : "OFFLINE"});
    });
  }

  addMission(mission) {
    const map = this.state.pendingPaymentsList.set(mission.id, mission);
    this.setState({ pendingPaymentsList: map });
  }

  removeMission(missionId) {
    const map = this.state.pendingPaymentsList.remove(missionId);
    this.setState({ pendingPaymentsList: map });
  }

  loadUIPreferences() {
    let listPreference = getListUIPreference(
      appConstants.LIST.PENDING_PAYMENTS
    );
    let defaultSort =
      listPreference && listPreference.sortPref
        ? listPreference.sortPref
        : [
            {
              id: "billedPayments",
              desc: false,
            },
          ];
    let pageSize =
      listPreference && listPreference.sortPref ? listPreference.pageSize : 20;

    return { defaultSort, pageSize };
  }

  onSortedChange(newSorted) {
    let currentPreference = getListUIPreference(
      appConstants.LIST.PENDING_PAYMENTS
    );
    currentPreference = currentPreference || {};
    currentPreference.sortPref = newSorted;
    setListUIPreference(appConstants.LIST.PENDING_PAYMENTS, currentPreference);
  }

  onPageSizeChange(pageIndex) {
    let currentPreference = getListUIPreference(
      appConstants.LIST.PENDING_PAYMENTS
    );
    currentPreference = currentPreference || {};
    currentPreference.pageSize = pageIndex;
    setListUIPreference(appConstants.LIST.PENDING_PAYMENTS, currentPreference);
  }

  toggleManualPaymentDialog = () => {
    this.setState({
      manualPaymentDialogOpen: !this.state.manualPaymentDialogOpen,
    });
  };

  setSelectedMission = (mission) => {
    this.setState({ setSelectedMission: mission });
  };
  componentWillUnmount() {
    unsetPaymentListUpdater();
  }

  getPendingPaymentList() {
    this.props.dispatch(asyncStart());
    return api
      .getPendingPayments()
      .then((resp) => {
        this.props.dispatch(asyncEnd());
        this.setState({ pendingPaymentsList: resp });
      })
      .catch((error) => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({ message: error.message }));
      });
  }

  render() {
    const columns = [
      {
        id: "billedPayments",
        Header: "Mission Number",
        accessor: "mission_number",
      },
      {
        Header: "User",
        accessor: "patient.user.name",
      },
      {
        Header: "Patient",
        accessor: "patient.name",
      },
      {
        Header: "Doctor",
        accessor: "doctor.user.name",
      },
      {
        Header: "Due Amount",
        accessor: "due_amount",
      },
      {
        id: 'date',
        Header: 'Mission Date',
        accessor: d =>  new Date(d.created_at),
        Cell: props => <span>{utils.toAppDate(props.value)}</span>,
        maxWidth:180,
        filterMethod: (filter, row) => {
          return filter === null || filter.value === null ||utils.isSameDay(filter.value, row[filter.id])
        },
        Filter: ({ filter, onChange }) =>
          <DatePicker
            cancelLabel='Clear'
            textFieldStyle={{height: '100%', position: 'inherit'}}
            value={filter ? filter.value : null}
            onDismiss={()=> onChange(null)}
            onChange={(event, date) => onChange(date)}
            />
      },
      {
        Header: "Update Payment",
        Cell: ({ original }) => (
          <RaisedButton
            label="Update"
            labelColor={white}
            backgroundColor="#14A46E"
            width="160px"
            onClick={(e) => {
              this.setState({
                manualPaymentDialogOpen: true,
                selectedMission: original,
              });
            }}
          />
        ),
      },
    ];

    let {
      pageSize,
      sortPref,
      pendingPaymentsList,
      socketConnection,
    } = this.state;
    let { isLoading } = this.props.application;
    let reactTableProps = {
      data: pendingPaymentsList.toArray(),
      columns,
      isLoading,
      noDataText: "No Missions Pending Payment Found",
      defaultPageSize: pageSize,
      defaultSorted: sortPref,
      onSortedChange: this.onSortedChange.bind(this),
      onPageSizeChange: this.onPageSizeChange.bind(this),
    };

    return (
      <div>
        <List
          title="Pending Payments"
          addNewBadge={socketConnection}
          reactTableProps={reactTableProps}
        />
        <ManualPaymentDialog
          open={this.state.manualPaymentDialogOpen}
          mission={this.state.selectedMission}
          toggleManualPaymentDialog={this.toggleManualPaymentDialog.bind(this)}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user,
  };
}

export default connect(mapStateToProps, null)(PendingPaymentsTableView);



// WEBPACK FOOTER //
// ./src/containers/pending-payment.js